/**
 * StoryRow — DS Pattern
 */

import { Badge, Avatar } from '../../atoms';
import styles from './StoryRow.module.css';

type StoryStatus = 'inbox' | 'in-progress' | 'done';

const STATUS_VARIANT: Record<StoryStatus, 'neutral' | 'warning' | 'success'> = {
  inbox: 'neutral', 'in-progress': 'warning', done: 'success',
};

interface StoryRowProps {
  id: string;
  title: string;
  status: StoryStatus;
  points: number;
  assignee?: string;
  className?: string;
}

export function StoryRow({ id, title, status, points, assignee, className = '' }: StoryRowProps) {
  return (
    <div className={`${styles.row} ${className}`}>
      <Badge variant="primary" className={styles.id}>{id}</Badge>
      <span className={styles.title}>{title}</span>
      <Badge variant={STATUS_VARIANT[status]}>{status}</Badge>
      <span className={styles.pts}>{points} pts</span>
      {assignee && <Avatar name={assignee} size="sm" />}
    </div>
  );
}
